import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
// Support both naming conventions:
// - REACT_APP_SUPABASE_ANON_KEY (common Supabase docs)
// - REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY (what some dashboards show)
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;
